import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LLink from "@components/LLink";
import LText from "@components/LText";
import UserAvatar from "@components/UserAvatar";
import { useManagedArtists } from "@hooks/trpc/useManagedArtists";
import * as React from "react";

const ArtistProfileCard = () => {
  const {
    artists: { data: artists },
  } = useManagedArtists();

  const artist = artists?.at(0);

  if (!artist) {
    return null;
  }

  const profileImageUrl = String(artist?.image ?? "");

  return (
    <LLink
      href={{ pathname: `/(app)/(tabs)/profile/artist/profile` }}
      sentryEventName="artist_profile_card"
    >
      <LBox
        flexDirection="row"
        backgroundColor="favouriteTileBg"
        px="s3"
        py="m1"
        borderRadius="m"
        justifyContent="space-between"
        alignItems={"center"}
      >
        <LBox flexDirection="row" gap="s2" alignItems="center">
          <UserAvatar image={profileImageUrl} size={56} />
          <LBox gap="s2">
            <LText fontWeight="800" fontSize={14} variant="bodyM2">
              {artist.name}
            </LText>
          </LBox>
        </LBox>
        <LIcon colors={{ color: "#E6725A" }} name="edit" size={28} />
      </LBox>
    </LLink>
  );
};

export default ArtistProfileCard;
